import { Suspense, lazy } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import OnboardLayout from "./components/layout/OnboardLayout";
import { ROUTES } from "./configs/routes";

const NotFoundPage = lazy(() => import("./pages/NotFound"));

function App() {
	return (
		<BrowserRouter>
			<Routes>
				<Route element={<OnboardLayout />}>
					{ROUTES.map(({ path, page: Page }, index) => (
						<Route
							key={index}
							path={path}
							element={
								<Suspense fallback={<></>}>
									<Page />
								</Suspense>
							}
						/>
					))}
				</Route>
				<Route
					path="*"
					element={
						<Suspense fallback={<></>}>
							<NotFoundPage />
						</Suspense>
					}
				/>
			</Routes>
		</BrowserRouter>
	);
}

export default App;
